/**
 * Coure SMS Delivery Service
 * Coure SMS Delivery service Api 
 *
 * OpenAPI spec version: v1.0
 * Contact: support@coure-tech.com
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';

import { ContentTransactionLog } from '../model/contentTransactionLog';
import { ContentTransactionLogDTO } from '../model/contentTransactionLogDTO';
import { ServiceTransactionLog } from '../model/serviceTransactionLog';
import { ServiceTransactionLogDtos } from '../model/serviceTransactionLogDtos';
import { ServiceTransactionLogDto } from '../model/serviceTransactionLogDto';
import { TupleOfLongAndDateTimeAndDateTime } from '../model/tupleOfLongAndDateTimeAndDateTime';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class BillingTransactionLogsService {

    protected basePath = 'http://10.1.1.123:30116';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public billingTransactionLogsCreateContentTransactionLog(model: ContentTransactionLogDTO, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public billingTransactionLogsCreateContentTransactionLog(model: ContentTransactionLogDTO, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public billingTransactionLogsCreateContentTransactionLog(model: ContentTransactionLogDTO, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public billingTransactionLogsCreateContentTransactionLog(model: ContentTransactionLogDTO, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling billingTransactionLogsCreateContentTransactionLog.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/BillingTransactionLogs/content/create`,
            model,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public billingTransactionLogsCreateServiceTransactionLog(model: ServiceTransactionLogDtos, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public billingTransactionLogsCreateServiceTransactionLog(model: ServiceTransactionLogDtos, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public billingTransactionLogsCreateServiceTransactionLog(model: ServiceTransactionLogDtos, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public billingTransactionLogsCreateServiceTransactionLog(model: ServiceTransactionLogDtos, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling billingTransactionLogsCreateServiceTransactionLog.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/BillingTransactionLogs/service/create`,
            model,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public billingTransactionLogsDeleteContentTransactionLog(id: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public billingTransactionLogsDeleteContentTransactionLog(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public billingTransactionLogsDeleteContentTransactionLog(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public billingTransactionLogsDeleteContentTransactionLog(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling billingTransactionLogsDeleteContentTransactionLog.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete(`${this.basePath}/api/BillingTransactionLogs/content/delete/${encodeURIComponent(String(id))}`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public billingTransactionLogsDeleteServiceTransactionLog(id: string, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public billingTransactionLogsDeleteServiceTransactionLog(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public billingTransactionLogsDeleteServiceTransactionLog(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public billingTransactionLogsDeleteServiceTransactionLog(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling billingTransactionLogsDeleteServiceTransactionLog.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.delete(`${this.basePath}/api/BillingTransactionLogs/service/delete/${encodeURIComponent(String(id))}`,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param transactionId 
     * @param serviceId 
     * @param contentId 
     * @param channel 
     * @param transactionTimeStamp 
     * @param content 
     * @param countryCode 
     * @param status 
     * @param startIndex 
     * @param count 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public billingTransactionLogsGetAllContentTransactionLogs(id?: string, transactionId?: number, serviceId?: number, contentId?: number, channel?: string, transactionTimeStamp?: Date, content?: string, countryCode?: string, status?: number, startIndex?: number, count?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ContentTransactionLog>>;
    public billingTransactionLogsGetAllContentTransactionLogs(id?: string, transactionId?: number, serviceId?: number, contentId?: number, channel?: string, transactionTimeStamp?: Date, content?: string, countryCode?: string, status?: number, startIndex?: number, count?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ContentTransactionLog>>>;
    public billingTransactionLogsGetAllContentTransactionLogs(id?: string, transactionId?: number, serviceId?: number, contentId?: number, channel?: string, transactionTimeStamp?: Date, content?: string, countryCode?: string, status?: number, startIndex?: number, count?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ContentTransactionLog>>>;
    public billingTransactionLogsGetAllContentTransactionLogs(id?: string, transactionId?: number, serviceId?: number, contentId?: number, channel?: string, transactionTimeStamp?: Date, content?: string, countryCode?: string, status?: number, startIndex?: number, count?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {












        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('Id', <any>id);
        }
        if (transactionId !== undefined && transactionId !== null) {
            queryParameters = queryParameters.set('TransactionId', <any>transactionId);
        }
        if (serviceId !== undefined && serviceId !== null) {
            queryParameters = queryParameters.set('ServiceId', <any>serviceId);
        }
        if (contentId !== undefined && contentId !== null) {
            queryParameters = queryParameters.set('ContentId', <any>contentId);
        }
        if (channel !== undefined && channel !== null) {
            queryParameters = queryParameters.set('Channel', <any>channel);
        }
        if (transactionTimeStamp !== undefined && transactionTimeStamp !== null) {
            queryParameters = queryParameters.set('TransactionTimeStamp', <any>transactionTimeStamp.toISOString());
        }
        if (content !== undefined && content !== null) {
            queryParameters = queryParameters.set('Content', <any>content);
        }
        if (countryCode !== undefined && countryCode !== null) {
            queryParameters = queryParameters.set('CountryCode', <any>countryCode);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('Status', <any>status);
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<ContentTransactionLog>>(`${this.basePath}/api/BillingTransactionLogs/content/getall`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param anqUserId 
     * @param dateFrom 
     * @param dateTo 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public billingTransactionLogsGetAllServiceProviderTransactionsByAnqUserIdAndDate(anqUserId?: number, dateFrom?: Date, dateTo?: Date, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceTransactionLogDto>>;
    public billingTransactionLogsGetAllServiceProviderTransactionsByAnqUserIdAndDate(anqUserId?: number, dateFrom?: Date, dateTo?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceTransactionLogDto>>>;
    public billingTransactionLogsGetAllServiceProviderTransactionsByAnqUserIdAndDate(anqUserId?: number, dateFrom?: Date, dateTo?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceTransactionLogDto>>>;
    public billingTransactionLogsGetAllServiceProviderTransactionsByAnqUserIdAndDate(anqUserId?: number, dateFrom?: Date, dateTo?: Date, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {




        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (anqUserId !== undefined && anqUserId !== null) {
            queryParameters = queryParameters.set('anqUserId', <any>anqUserId);
        }
        if (dateFrom !== undefined && dateFrom !== null) {
            queryParameters = queryParameters.set('dateFrom', <any>dateFrom.toISOString());
        }
        if (dateTo !== undefined && dateTo !== null) {
            queryParameters = queryParameters.set('dateTo', <any>dateTo.toISOString());
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<ServiceTransactionLogDto>>(`${this.basePath}/api/BillingTransactionLogs/GetAllServiceProviderTransactionsByAnqUserIdAndDate`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param transactionId 
     * @param serviceId 
     * @param clientId 
     * @param channel 
     * @param transactionTimeStamp 
     * @param operationCount 
     * @param service 
     * @param status 
     * @param billingTaskInterval 
     * @param startIndex 
     * @param count 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public billingTransactionLogsGetAllServiceTransactionLog(id?: string, transactionId?: string, serviceId?: string, clientId?: string, channel?: string, transactionTimeStamp?: Date, operationCount?: number, service?: string, status?: number, billingTaskInterval?: number, startIndex?: number, count?: number, observe?: 'body', reportProgress?: boolean): Observable<Array<ServiceTransactionLog>>;
    public billingTransactionLogsGetAllServiceTransactionLog(id?: string, transactionId?: string, serviceId?: string, clientId?: string, channel?: string, transactionTimeStamp?: Date, operationCount?: number, service?: string, status?: number, billingTaskInterval?: number, startIndex?: number, count?: number, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Array<ServiceTransactionLog>>>;
    public billingTransactionLogsGetAllServiceTransactionLog(id?: string, transactionId?: string, serviceId?: string, clientId?: string, channel?: string, transactionTimeStamp?: Date, operationCount?: number, service?: string, status?: number, billingTaskInterval?: number, startIndex?: number, count?: number, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Array<ServiceTransactionLog>>>;
    public billingTransactionLogsGetAllServiceTransactionLog(id?: string, transactionId?: string, serviceId?: string, clientId?: string, channel?: string, transactionTimeStamp?: Date, operationCount?: number, service?: string, status?: number, billingTaskInterval?: number, startIndex?: number, count?: number, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {













        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (id !== undefined && id !== null) {
            queryParameters = queryParameters.set('Id', <any>id);
        }
        if (transactionId !== undefined && transactionId !== null) {
            queryParameters = queryParameters.set('TransactionId', <any>transactionId);
        }
        if (serviceId !== undefined && serviceId !== null) {
            queryParameters = queryParameters.set('ServiceId', <any>serviceId);
        }
        if (clientId !== undefined && clientId !== null) {
            queryParameters = queryParameters.set('ClientId', <any>clientId);
        }
        if (channel !== undefined && channel !== null) {
            queryParameters = queryParameters.set('Channel', <any>channel);
        }
        if (transactionTimeStamp !== undefined && transactionTimeStamp !== null) {
            queryParameters = queryParameters.set('TransactionTimeStamp', <any>transactionTimeStamp.toISOString());
        }
        if (operationCount !== undefined && operationCount !== null) {
            queryParameters = queryParameters.set('OperationCount', <any>operationCount);
        }
        if (service !== undefined && service !== null) {
            queryParameters = queryParameters.set('Service', <any>service);
        }
        if (status !== undefined && status !== null) {
            queryParameters = queryParameters.set('Status', <any>status);
        }
        if (billingTaskInterval !== undefined && billingTaskInterval !== null) {
            queryParameters = queryParameters.set('BillingTaskInterval', <any>billingTaskInterval);
        }
        if (startIndex !== undefined && startIndex !== null) {
            queryParameters = queryParameters.set('startIndex', <any>startIndex);
        }
        if (count !== undefined && count !== null) {
            queryParameters = queryParameters.set('count', <any>count);
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<Array<ServiceTransactionLog>>(`${this.basePath}/api/BillingTransactionLogs/service/getall`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public billingTransactionLogsGetContentTransactionLogById(id: string, observe?: 'body', reportProgress?: boolean): Observable<ContentTransactionLog>;
    public billingTransactionLogsGetContentTransactionLogById(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ContentTransactionLog>>;
    public billingTransactionLogsGetContentTransactionLogById(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ContentTransactionLog>>;
    public billingTransactionLogsGetContentTransactionLogById(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling billingTransactionLogsGetContentTransactionLogById.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ContentTransactionLog>(`${this.basePath}/api/BillingTransactionLogs/content/get/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param id 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public billingTransactionLogsGetServiceTransactionLogById(id: string, observe?: 'body', reportProgress?: boolean): Observable<ServiceTransactionLog>;
    public billingTransactionLogsGetServiceTransactionLogById(id: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<ServiceTransactionLog>>;
    public billingTransactionLogsGetServiceTransactionLogById(id: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<ServiceTransactionLog>>;
    public billingTransactionLogsGetServiceTransactionLogById(id: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling billingTransactionLogsGetServiceTransactionLogById.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<ServiceTransactionLog>(`${this.basePath}/api/BillingTransactionLogs/service/get/${encodeURIComponent(String(id))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param resourceId 
     * @param clientId 
     * @param startDate 
     * @param endDate 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public billingTransactionLogsGetServiceTransactionLogs(resourceId?: string, clientId?: number, startDate?: Date, endDate?: Date, observe?: 'body', reportProgress?: boolean): Observable<TupleOfLongAndDateTimeAndDateTime>;
    public billingTransactionLogsGetServiceTransactionLogs(resourceId?: string, clientId?: number, startDate?: Date, endDate?: Date, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TupleOfLongAndDateTimeAndDateTime>>;
    public billingTransactionLogsGetServiceTransactionLogs(resourceId?: string, clientId?: number, startDate?: Date, endDate?: Date, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TupleOfLongAndDateTimeAndDateTime>>;
    public billingTransactionLogsGetServiceTransactionLogs(resourceId?: string, clientId?: number, startDate?: Date, endDate?: Date, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {





        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (resourceId !== undefined && resourceId !== null) {
            queryParameters = queryParameters.set('resourceId', <any>resourceId);
        }
        if (clientId !== undefined && clientId !== null) {
            queryParameters = queryParameters.set('clientId', <any>clientId);
        }
        if (startDate !== undefined && startDate !== null) {
            queryParameters = queryParameters.set('startDate', <any>startDate.toISOString());
        }
        if (endDate !== undefined && endDate !== null) {
            queryParameters = queryParameters.set('endDate', <any>endDate.toISOString());
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<TupleOfLongAndDateTimeAndDateTime>(`${this.basePath}/api/BillingTransactionLogs/GetServiceTransactionLogs`,
            {
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public billingTransactionLogsUpdateContentTransactionLog(model: ContentTransactionLog, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public billingTransactionLogsUpdateContentTransactionLog(model: ContentTransactionLog, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public billingTransactionLogsUpdateContentTransactionLog(model: ContentTransactionLog, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public billingTransactionLogsUpdateContentTransactionLog(model: ContentTransactionLog, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling billingTransactionLogsUpdateContentTransactionLog.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/BillingTransactionLogs/content/update`,
            model,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * 
     * @param model 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public billingTransactionLogsUpdateServiceTransactionLog(model: ServiceTransactionLog, observe?: 'body', reportProgress?: boolean): Observable<Blob>;
    public billingTransactionLogsUpdateServiceTransactionLog(model: ServiceTransactionLog, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<Blob>>;
    public billingTransactionLogsUpdateServiceTransactionLog(model: ServiceTransactionLog, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<Blob>>;
    public billingTransactionLogsUpdateServiceTransactionLog(model: ServiceTransactionLog, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (model === null || model === undefined) {
            throw new Error('Required parameter model was null or undefined when calling billingTransactionLogsUpdateServiceTransactionLog.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        let httpHeaderAccepts: string[] = [
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.post(`${this.basePath}/api/BillingTransactionLogs/service/update`,
            model,
            {
                responseType: "blob",
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
